module.exports = __webpack_public_path__ + "static/media/27OCHA7.a03c3219.jpg";